import React, { Component } from "react";

export default class WaitContainer extends Component {
  render() {
    return (
      <div className="container">
        <div className="row">
          <div className="col-sm-12">
            <div className="alert alert-info" role="alert">
              <h3>Just a moment...</h3>
              <p>Someone from your table is choosing how to pay the bill...</p>
              <h1>
                <i className="fa fa-spinner fa-pulse"></i>
              </h1>
            </div>
          </div>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/Components/WaitContainer.js